import $ from 'jquery';

import {isBrowser} from 'lib/Browser';

import {Optional} from './util/Types';

let csrfToken: Optional<string>;
if (isBrowser) {
  const $token = $('meta[name="csrf-token"]');
  csrfToken = $token.attr('content');
  // Delete from DOM to make access more difficult.
  $token.remove();
} else {
  csrfToken = null;
}

// Adapted from Django: https://docs.djangoproject.com/en/dev/ref/contrib/csrf/
export function csrfSetter(
  this: JQueryAjaxSettings,
  xhr: XMLHttpRequest,
  settings: JQueryAjaxSettings
): void {
  if (csrfToken != null && !/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type!) && !this.crossDomain) {
    xhr.setRequestHeader('X-CSRFToken', csrfToken);
  }
}

export const token = csrfToken;
